module.exports = __webpack_public_path__ + "media/images/emblems/Bueren-blason-8ba0aa80503c9164cf27d9741a2111a3.png";